import { render, staticRenderFns } from "./NewsTutorialListItem.vue?vue&type=template&id=1918b428&scoped=true"
import script from "./NewsTutorialListItem.vue?vue&type=script&lang=js"
export * from "./NewsTutorialListItem.vue?vue&type=script&lang=js"
import style0 from "./NewsTutorialListItem.vue?vue&type=style&index=0&id=1918b428&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1918b428",
  null
  
)

export default component.exports